module.exports = __webpack_public_path__ + "static/media/how-it-works-2.59dd2104.jpg";